import { Component, OnInit, AfterViewInit, Input, OnChanges } from '@angular/core';
import { Product, ProductResponse } from '../../../../models/Product';
import { ProductService } from '../../../../services/product.service';
import { FlashService } from '../../../../services/utility/flash.service';
import { AdminUrlType } from "../../../../services/utility/general-helper.service";
import * as $ from 'jquery';


// enum AdminUrlType{
//   Dashboard,
//   ProductList,
//   ProductEdit,
//   Customers
// }

@Component({
  selector: 'app-admin-product-list',
  templateUrl: './admin-product-list.component.html',
  styleUrls: ['./admin-product-list.component.scss']
})
export class AdminProductListComponent implements OnInit {
AdminUrlType = AdminUrlType;
@Input('products') products:Product[];  //linked to parent 'admin-products', will initially be null until products are loaded

  constructor(
    private productService:ProductService, 
    private flashService:FlashService,
  ) { }

  
  ngOnInit(){ 
    //this works!  - was used to test product-list.html with 0 products
    // setTimeout(() => {
    //   console.log('null!');
    //   this.products = null;      
    // }, 3000);

  }

  onActiveClicked(product){
    //get a copy of the product and change it's value
    let productCopy = Product.fromJson(product);
    productCopy.active = !productCopy.active

    //save the edit immediately
    this.productService.editProduct(productCopy).subscribe((productResponse:ProductResponse) => {
      // console.log('pce: res', productResponse);


      //flashMessage 'saved' upon success
      // Show a flashElement, inline, next to the checkbox, green 'saved'  See nav-signin
      if(productResponse.success){  
        //need to wait a tick, since product will regenerate on receiving update to productServie.product$
        let flashService = this.flashService;
        setTimeout(function() {
          // let element = $('#flashSaved'+productCopy.sku);
          // console.log('flashing element', element);
          let elementId = '#flashSaved'+productCopy.sku;
          flashService.flashElementWithId(elementId, 'Saved', 4000);
        }, 0);
      } else {
        //flashmessage error
        console.log('pce: error editing product');
        this.flashService.flashMessage.show(productResponse.msg, {cssClass:'alert-danger', timeout:4000});
      }
    });
  }

  //Used so that when products are updated due to an edit to 'active' via the checkbox,
  // the table will be redrawn with prior Flash-Element 'Saved' still shown until timeout shuts them down.
  shouldShowFlashSaved(sku){
    let elementId = '#flashSaved'+sku;
    let flashTracker = this.flashService.flashTracker;
    if(flashTracker[elementId] > 0){
      return true;
    } else {
      return false;
    }
  }


}





//======================
//Unused Code
// this.flashService.flashElement($(elementId), 'Saved', 4000);
// if(showing){
//   console.log('showing')
//   $(elementId).removeClass( "invisible" );
// } else {
//   console.log('hiding');
//   $(elementId).addClass( "invisible" );
// }          
// this.flashService.flashElement(element, 'Saved', 4000);
// this.flashService.flashElement(flashSaved, 'Saved', 4000);
// this.flashMessagesService.show('Successfully saved edits to product.', {cssClass:'alert-success', timeout:4000});


// ngOnChanges(){
//   console.log('ngonchanges')

//   // console.log('afterViewChecked');
//   // this.productService.product$.subscribe((products) => {
//   //   console.log('apl: observed new products:', products);

//   //   let flashTracker = this.flashService.flashTracker;
//   //   // console.log('flashTracker', flashTracker);
    
//   //   //hide element if it's not in the flashTracker
//   //   setTimeout(function() {
//   //     for(let product of products){
//   //       let elementId = '#flashSaved'+product.sku;
//   //       if(!flashTracker[elementId]){
//   //         $(elementId).hide();
//   //       }
//   //     }
//   //   }, 0);

//     // setTimeout(function() {
//       // for(let elementId of Object.keys(flashTracker)){
//       //   if(flashTracker[elementId] > 0){
//       //     // console.log('re-showing element', $(elementId));
//       //     $(elementId).show();
//       //   }
//       // }
//     // }, 0);

//     // //NO! - you don't want to hide them everytime products in downloaded.    
//     // // //wait a tick to access flashSaved
//     //     let flashTracker = this.flashService.flashTracker;
//     //     console.log('flashTracker', flashTracker)
//     //     setTimeout(function() {           
//     //       // console.log('flashTracker[\'flashSaved1010\']', flashService.flashTracker['flashSaved1010']);
    
//     //       for(let product of products){
//     //         let elementId = '#flashSaved'+product.sku;
//     //         let flashCount = flashTracker[elementId];
//     //         if(flashCount > 0){
//     //           console.log('****flash count for '+elementId+' is '+flashCount);
//     //         }
            
//     //         // $(elementId).hide();
//     //         // let flashSaved = $(elementId);
//     //         // if (!product.active){ flashSaved.hide() }
//     //       }
//     //     }, 0);

//   // });

// }

        // console.log('test element', $('#flashSaved1010'));


// //NO! - the table was being redrawn in its initial state BEFORE this was executed, 
// // so it looked like a glitch for a split second every time you clicked the activate box.
//  // Better solution was to have a dedicated method bound to an NGStyle to hide or show 
// // the flash-element based on it's existence in the flashTracker object.
// //show unexpired flashMessage
// let flashTracker = this.flashService.flashTracker;
// // console.log('flashTracker', flashTracker);
// setTimeout(function() {
//   for(let elementId of Object.keys(flashTracker)){
//     if(flashTracker[elementId] > 0){
//       // console.log('re-showing element', $(elementId));
//       $(elementId).show();
//     }
//   }
// }, 0);


// WEBPACK FOOTER //
// ./src/app/components/admin/admin-products/admin-product-list/admin-product-list.component.ts